import { Navigate, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { EmptyState, PageLoader } from "@/components/common/Page";

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
};

export const RoleGate = ({ roles, children }) => {
  const { user } = useAuth();
  if (roles && !roles.includes(user?.role)) {
    return (
      <EmptyState
        icon={ShieldAlert}
        title="You don't have access to this page"
        description="Your role doesn't include this area. Ask an Admin if you think you need it."
        testId="forbidden-state"
      />
    );
  }
  return children;
};
